import * as React from 'react'
import { cn } from '../../lib/utils'

/**
 * Animated disclosure content shared by Plant tree rows and compact entity
 * metadata. Children remain mounted through the closing transition, then
 * unmount so collapsed connection groups do not retain large peer lists.
 */
export function CollapsibleContent({
  open,
  children
}: {
  open: boolean
  children: React.ReactNode
}): React.ReactElement {
  const [rendered, setRendered] = React.useState(open)
  if (open && !rendered) setRendered(true)

  const onTransitionEnd = (event: React.TransitionEvent<HTMLDivElement>): void => {
    if (event.target === event.currentTarget && !open) setRendered(false)
  }

  return (
    <div
      className={cn(
        'grid transition-[grid-template-rows,visibility] duration-200 ease-out',
        open ? 'grid-rows-[1fr]' : 'invisible grid-rows-[0fr]'
      )}
      onTransitionEnd={onTransitionEnd}
    >
      <div className="min-h-0 overflow-hidden">{rendered ? children : null}</div>
    </div>
  )
}
